export const i18n = {
  en: {
    dir: "ltr",
    logo: "THE QUIET SWORD",
    nav: { about: "About", framework: "The Three C's", services: "Services", book: "Book", contact: "Contact" },
    hero: {
      eyebrow: "A Teacher of Warriors on Pressure, Restraint, and Real Power",
      titleLines: ["THE QUIET", "SWORD."],
      subtitle:
        "Forty-eight years as a practitioner and a teacher of warriors, and of the executives, commanders, and instructors who lead them. The greatest ones I have ever trained are those who almost never fight.",
      book: "Book a Lecture",
      framework: "The Three C's",
    },
    creds: [
      { num: "48", lbl: "Years as a practitioner and teacher of warriors." },
      { num: "30+", lbl: "Years Trained Under One Teacher" },
      { num: "1", lbl: "Combat Doctrine Led, Prime Minister's Office" },
      { num: "3", lbl: "The Framework: Capability, Composure, Choice" },
    ],
    about: {
      eyebrow: "About Benjamin",
      title: "Forty-eight years as a practitioner and a teacher of warriors.",
      p1: "I started as a twelve-year-old boy, trembling at the sound of my teacher's voice. I trained under that same man, Dennis Hanover, for more than thirty years. I went on to lead the combat doctrine of the Prime Minister's Office, and to run debriefs of operations I cannot tell you about.",
      p2: "I failed many times. Some of my students failed, and some failed in ways I myself found hard to recover from. There were a few successes I will not talk about either. What I know now, after all of it, I call the quiet sword. It is what I teach.",
      link: "See the framework",
    },
    framework: {
      eyebrow: "The Framework",
      title: "Three qualities separate those who carry a quiet sword from those who do not.",
      intro:
        "Not personality traits. Not gifts. Skills. And like all skills, they can be developed, but only in the right order. Each one rests on the one before it.",
      cards: [
        { n: "01", title: "Capability", body: "The precondition. The real level of skill a warrior must hold before pressure means anything at all. Without it, composure has nothing to stand on, and choice has no foundation." },
        { n: "02", title: "Composure", body: "Not calm. It is the ability to keep functioning while fear is present. A frightened person who still performs well: that is composure. Capability tells you what to do; composure lets you do it." },
        { n: "03", title: "Choice", body: "Real decision-making under pressure. The untrained mind locks up and repeats the last thing it knew. A person with capability and composure can see what is in front of them, and choose." },
      ],
      quotes: ['"Restraint without capability is just fear in disguise."', '"Pressure reveals. It does not create."'],
    },
    marquee: ["Capability", "Composure", "Choice", "Pressure Reveals", "Restraint", "Real Power"],
    story: {
      eyebrow: "The Signature Story",
      title: "N. and A. came to me in the same month.",
      p1: "A. arrived to the Mossad unit decorated, recommended by his commanders. N. arrived with no combat experience at all. Same drills. Same pressure. Under it, A. unraveled. He pulled off his gear and stormed out of the hall. N. stood in the room, tears at the corners of her eyes, and did not move. She did not quit.",
      p2: "Years later, on an operation, she walked out of a field interrogation together with the checkpoint commander, both smiling, and the mission continued without a single act of violence. She acted as the quiet sword.",
      quote: '"She is my greatest victory as a teacher."',
    },
    services: {
      eyebrow: "Services",
      title: "Bring the quiet sword to your organization.",
      cards: [
        { n: "01", title: "Keynote: The Quiet Sword", body: "The full talk on pressure, restraint, and the three qualities that separate those who hold from those who break, built for leadership offsites and conferences.", cta: "Book a Lecture" },
        { n: "02", title: "Executive Workshops", body: "Half-day and full-day sessions building capability, composure, and choice into a leadership team's decision-making under real pressure.", cta: "Book a Workshop" },
        { n: "03", title: "Training Programs", body: "Multi-year combatives and command-presence programs for military, law enforcement, and security instructors, customized to meet the specific needs of your organization.", cta: "Book a Program" },
      ],
    },
    book: {
      eyebrow: "The Book",
      title: "The Book of the Warriors' Teacher",
      body: "Forty-eight years of lessons on capability, composure, and choice, and on finding, or becoming, a teacher whose standard you have not yet met.",
      button: "Buy on Amazon",
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_responsive-web-56/artifacts/6m27y4j3_IMG_8461.jpeg",
      buyLink: "https://www.amazon.com/dp/B0HHXRMDC9",
      button2: "Buy at Walmart",
      buyLink2: "https://www.walmart.com/ip/The-Book-of-The-Warriors-Teacher-Paperback-9798904187033/20609318678?classType=REGULAR",
      mockup: false,
    },
    contact: {
      eyebrow: "Find Your Teacher",
      title: "Ready to build the conditions to draw it?",
      body: "Tell me about your organization and what you're training for. I'll follow up within 48 hours.",
      placeholders: { name: "Name *", email: "Email *", phone: "Phone", country: "Country", subjectDefault: "Subject of enquiry *", message: "What are you looking to book: a lecture, workshop, or training program?" },
      subjects: ["Keynote / Lecture", "Executive Workshop", "Training Program", "About the Book", "Other"],
      submit: "Send Message",
      sending: "Sending…",
      successMsg: "Thank you — I'll follow up within 48 hours.",
      fill: "Please fill in name, email, subject and message.",
      error: "Something went wrong. Please try again.",
      footerName: "BENJAMIN",
      rights: "All rights reserved.",
    },
    bookPage: {
      metaTitle: "The Book of the Warriors' Teacher — by Benny Mayer",
      eyebrow: "The Book",
      h1: "Is a great fighter necessarily a great teacher?",
      sub: "The Book of the Warriors' Teacher is a practical guide for instructors, coaches, and students who want to understand how capability, judgment, and restraint are built under pressure.",
      ctaPrimary: "Choose an edition & buy",
      ctaSecondary: "Read the first chapter",
      whoLine: "Written for combat instructors — and for those who want to become one.",
      videoTitle: "A word from the author",
      videoNote: "Short film coming soon.",
      problemsTitle: "Three problems this book solves",
      problems: [
        { n: "01", t: "Building the real thing under pressure", b: "How capability, judgment and restraint are actually developed — in the right order — so they hold when it matters." },
        { n: "02", t: "Becoming a teacher, not just a fighter", b: "Why a skilled operator is not automatically a good instructor, and what closes that gap." },
        { n: "03", t: "Choosing the right teacher", b: "How to recognize a teacher whose standard is worth meeting — and how to become one." },
      ],
      forTitle: "Who it's for",
      forList: ["Combat and self-defense instructors", "Commanders and coaches who train under pressure", "Serious students choosing a path and a teacher"],
      notForTitle: "Who it's not for",
      notForList: ["Anyone looking for a quick book of techniques or 'tricks'", "Readers who want theory with no real-world application"],
      reviewsTitle: "What readers say",
      reviewsAgg: "5.0 / 5 · 18 reviews on Niv Books",
      reviews: [
        { name: "Daniel", text: "Interesting and readable, and remarkably thorough. The author's professionalism and personal experience show throughout, with many stories that make it practical. Highly recommended for anyone in the field." },
        { name: "Avi G.", text: "I truly enjoyed it — it taught me. It will sit with honor next to The Art of War. Written in a useful, flowing way that makes it easy to return to relevant chapters. Highly recommended!" },
      ],
      buyTitle: "Choose your edition",
      buyNote: "Available in print and digital.",
      editions: [
        { store: "amazon", label: "Amazon — Paperback (English)", meta: "Ships worldwide", cta: "Buy on Amazon" },
        { store: "walmart", label: "Walmart — Paperback (English)", meta: "US shipping", cta: "Buy at Walmart" },
        { store: "niv", label: "Niv Books — Hebrew edition", meta: "Digital ₪40 · Print ₪98", cta: "Buy on Niv Books" },
      ],
      amazonFallback: "Amazon listing temporarily unavailable — get an update when it returns.",
      amazonNotifyCta: "Notify me when it's back",
      leadTitle: "Read the first chapter",
      leadBody: "Enter your email and I'll send you the opening chapter and a short instructor's checklist.",
      leadCta: "Send me the chapter",
      bulkTitle: "Bulk & team orders",
      bulkBody: "Training a unit or a team? Tell me how many copies you need and I'll arrange it.",
      bulkCta: "Request a bulk order",
      authorTitle: "About the author",
      authorBody: "Benny Mayer has spent his life training warriors and combat instructors in Israel's defense establishment — forty years with the best fighters we have. He specializes in martial arts and human-performance improvement: reaction, power development, and functioning under pressure.",
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "What's inside the book?", a: "Three parts — the Teacher, the Teaching, and the Student — across 208 pages." },
        { q: "Which formats are available?", a: "Hebrew: digital (₪40) and print (₪98) on Niv Books. English: paperback on Amazon and Walmart." },
        { q: "Do you ship internationally?", a: "Yes — the English paperback ships worldwide via Amazon and Walmart." },
        { q: "Can I order in bulk for my team?", a: "Absolutely. Use the bulk request button and I'll get back to you." },
      ],
      secondaryTitle: "Bring it to your organization",
      secondaryBody: "Prefer it live? Explore the lectures and workshops.",
      secondaryCta: "See lectures & workshops",
      backToSite: "Main site",
      emailPlaceholder: "Your email *",
      namePlaceholder: "Name",
      notePlaceholder: "How many copies, and for whom?",
      sending: "Sending…",
      thanks: "Thank you — I'll be in touch shortly.",
      errorMsg: "Something went wrong. Please try again.",
    },
  },

  he: {
    dir: "rtl",
    logo: "החרב השקטה",
    nav: { about: "אודות", framework: "שלוש התכונות", services: "שירותים", book: "הספר", contact: "צור קשר" },
    hero: {
      eyebrow: "מורה של לוחמים על לחץ, איפוק וכוח אמיתי",
      titleLines: ["החרב", "השקטה."],
      subtitle:
        "ארבעים ושמונה שנים כמתרגל וכמורה של לוחמים, ושל המנהלים, המפקדים והמדריכים שמובילים אותם. הגדולים ביותר שאימנתי אי־פעם הם אלה שכמעט לעולם אינם נלחמים.",
      book: "הזמנת הרצאה",
      framework: "שלוש התכונות",
    },
    creds: [
      { num: "48", lbl: "שנים כתלמיד וכמורה של לוחמים." },
      { num: "30+", lbl: "שנות אימון תחת מורה אחד" },
      { num: "1", lbl: "דוקטרינת לחימה שהובלתי, משרד ראש הממשלה" },
      { num: "3", lbl: "המסגרת: יכולת, קור רוח, הכרעה" },
    ],
    about: {
      eyebrow: "אודות בני מאיר",
      title: "ארבעים ושמונה שנים כמתרגל וכמורה של לוחמים.",
      p1: "התחלתי כילד בן שתים־עשרה, רועד לשמע קולו של מורי. התאמנתי אצל אותו אדם, דניס הנובר, במשך יותר משלושים שנה. בהמשך הובלתי את דוקטרינת הלחימה של משרד ראש הממשלה, וניהלתי תחקירים של מבצעים שאיני יכול לספר עליהם.",
      p2: "נכשלתי פעמים רבות. חלק מתלמידיי נכשלו, וחלקם נכשלו בדרכים שהתקשיתי להתאושש מהן בעצמי. היו גם כמה הצלחות שלא אדבר עליהן. מה שאני יודע כיום, אחרי הכול, אני מכנה החרב השקטה. זה מה שאני מלמד.",
      link: "לצפייה במסגרת",
    },
    framework: {
      eyebrow: "המסגרת",
      title: "שלוש תכונות מפרידות בין מי שנושא חרב שקטה לבין מי שלא.",
      intro:
        "לא תכונות אופי. לא מתנות. מיומנויות. וכמו כל מיומנות, ניתן לפתח אותן — אך רק בסדר הנכון. כל אחת נשענת על זו שלפניה.",
      cards: [
        { n: "01", title: "יכולת", body: "התנאי המקדים. רמת המיומנות האמיתית שעל לוחם להחזיק בה לפני שללחץ יש בכלל משמעות. בלעדיה, לקור הרוח אין על מה לעמוד, ולבחירה אין בסיס." },
        { n: "02", title: "קור רוח", body: "לא רוגע. זו היכולת להמשיך לתפקד בזמן שהפחד נוכח. אדם מבוהל שעדיין מתפקד היטב — זהו קור רוח. היכולת אומרת לך מה לעשות; קור הרוח מאפשר לך לעשות זאת." },
        { n: "03", title: "הכרעה", body: "קבלת החלטות אמיתית תחת לחץ. המוח הלא־מאומן נתקע וחוזר על הדבר האחרון שידע. אדם בעל יכולת וקור רוח יכול לראות את מה שלפניו, ולהכריע." },
      ],
      quotes: ['"איפוק ללא יכולת הוא רק פחד בתחפושת."', '"לחץ מגלה — הוא אינו יוצר."'],
    },
    marquee: ["יכולת", "קור רוח", "הכרעה", "לחץ מגלה", "איפוק", "כוח אמיתי"],
    story: {
      eyebrow: "הסיפור המכונן",
      title: "נ׳ ו־א׳ הגיעו אליי באותו החודש.",
      p1: "א׳ הגיע ליחידת המוסד מעוטר, מומלץ על ידי מפקדיו. נ׳ הגיעה ללא כל ניסיון קרבי. אותם תרגילים. אותו לחץ. תחתיו, א׳ התפרק. הוא פשט מעליו את הציוד ויצא בסערה מהאולם. נ׳ נותרה עומדת בחדר, דמעות בזוויות עיניה, ולא זזה. היא לא ויתרה.",
      p2: "שנים לאחר מכן, במבצע, היא יצאה מחקירת שדה יחד עם מפקד המחסום, שניהם מחייכים, והמשימה נמשכה ללא מעשה אלימות אחד. היא פעלה כחרב השקטה.",
      quote: '"היא הניצחון הגדול ביותר שלי כמורה."',
    },
    services: {
      eyebrow: "שירותים",
      title: "הביאו את החרב השקטה לארגון שלכם.",
      cards: [
        { n: "01", title: "הרצאת מפתח: החרב השקטה", body: "ההרצאה המלאה על לחץ, איפוק, ושלוש התכונות המפרידות בין מי שמחזיק מעמד לבין מי שנשבר — בנויה לכנסים ולמפגשי הנהלה.", cta: "הזמנת הרצאה" },
        { n: "02", title: "סדנאות למנהלים", body: "מפגשים של חצי יום ויום מלא הבונים יכולת, קור רוח ובחירה בתוך קבלת ההחלטות של צוות ההנהלה תחת לחץ אמיתי.", cta: "הזמנת סדנה" },
        { n: "03", title: "תוכניות אימון", body: "תוכניות לשיפור ביצועים למנהלים הנדרשים בקבלת החלטות ולתפקוד במצבי לחץ, מותאמות לצרכים הספציפיים של הארגון שלכם.", cta: "הזמנת תוכנית" },
      ],
    },
    book: {
      eyebrow: "הספר",
      title: "הספר של מורה הלחימה",
      body: "ארבעים ושמונה שנים של לקחים על יכולת, קור רוח ובחירה, ועל מציאה — או הפיכה — למורה שאת הרף שלו טרם השגת.",
      button: "רכשו את הספר שלי",
      image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_responsive-web-56/artifacts/ghgy3nat_BenjaminMayer_Mockup.PNG",
      buyLink: "https://nivbook.co.il/product/הספר-של-מורה-הלחימה/",
      mockup: true,
    },
    contact: {
      eyebrow: "מצאו את המורה שלכם",
      title: "מוכנים לבנות את החרב השקטה?",
      body: "ספרו לי על הארגון שלכם ועל מה שאתם מתאמנים לקראתו. אחזור אליכם תוך 48 שעות.",
      placeholders: { name: "שם *", email: "אימייל *", phone: "טלפון", country: "מדינה", subjectDefault: "נושא הפנייה *", message: "מה תרצו להזמין: הרצאה, סדנה או תוכנית אימון?" },
      subjects: ["הרצאת מפתח", "סדנה למנהלים", "תוכנית אימון", "אודות הספר", "אחר"],
      submit: "שליחת הודעה",
      sending: "שולח…",
      successMsg: "תודה — אחזור אליך תוך 48 שעות.",
      fill: "נא למלא שם, אימייל, נושא והודעה.",
      error: "משהו השתבש. אנא נסו שוב.",
      footerName: "בני מאיר",
      rights: "כל הזכויות שמורות.",
    },
    bookPage: {
      metaTitle: "הספר של מורה הלחימה — מאת בני מאיר",
      eyebrow: "הספר",
      h1: "האם לוחם מצוין הוא בהכרח מורה מצוין?",
      sub: "הספר של מורה הלחימה הוא מדריך מעשי למדריכים, מאמנים ותלמידים המבקשים להבין כיצד בונים יכולת, שיקול-דעת וריסון בתנאי לחץ.",
      ctaPrimary: "בחרו מהדורה ורכשו את הספר",
      ctaSecondary: "קראו את הפרק הראשון",
      whoLine: "נכתב עבור מורי לחימה — ועבור אלה שרוצים להפוך למורים.",
      videoTitle: "דבר המחבר",
      videoNote: "סרטון קצר — בקרוב.",
      problemsTitle: "שלוש בעיות שהספר פותר",
      problems: [
        { n: "01", t: "לבנות את הדבר האמיתי תחת לחץ", b: "כיצד באמת מפתחים יכולת, שיקול-דעת וריסון — בסדר הנכון — כך שיחזיקו כשצריך." },
        { n: "02", t: "להפוך למורה, לא רק ללוחם", b: "מדוע לוחם מיומן אינו בהכרח מדריך טוב, ומה סוגר את הפער." },
        { n: "03", t: "לבחור את המורה הנכון", b: "כיצד לזהות מורה שהרף שלו שווה לפגוש — וכיצד להפוך לאחד כזה." },
      ],
      forTitle: "למי הספר מתאים",
      forList: ["מדריכי לחימה והגנה עצמית", "מפקדים ומאמנים שמאמנים בתנאי לחץ", "תלמידים רציניים שבוחרים דרך ומורה"],
      notForTitle: "למי פחות",
      notForList: ["מי שמחפש ספר טכניקות או 'טריקים' מהיר", "מי שרוצה תיאוריה בלי יישום מעשי"],
      reviewsTitle: "מה הקוראים אומרים",
      reviewsAgg: "5.0 / 5 · 18 חוות דעת בספרי ניב",
      reviews: [
        { name: "דניאל", text: "ספר מעניין וקריא, מקיף מאוד ומכסה בפירוט את כל ההיבטים. המקצועיות והניסיון האישי של המחבר ניכרים לאורך כל הספר, עם הרבה דוגמאות שמעניקות הבט מעשי. ממליץ מאוד." },
        { name: "אבי ג.", text: "נהנתי מאוד לקרוא את הספר — לימד אותי! ימצא מקום של כבוד ליד 'אמנות המלחמה'. כתוב בצורה שימושית, מעניינת וקולחת, ומאפשר חזרה קלה לפרקים הרלוונטיים. מומלץ ביותר!" },
      ],
      buyTitle: "בחרו מהדורה",
      buyNote: "זמין במודפס ובדיגיטלי.",
      editions: [
        { store: "niv", label: "ספרי ניב — מהדורה עברית", meta: "דיגיטלי ₪40 · מודפס ₪98", cta: "רכשו בספרי ניב" },
        { store: "amazon", label: "Amazon — כריכה רכה (אנגלית)", meta: "משלוח עולמי", cta: "רכשו באמזון" },
        { store: "walmart", label: "Walmart — כריכה רכה (אנגלית)", meta: "משלוח בארה\"ב", cta: "רכשו בוולמארט" },
      ],
      amazonFallback: "רישום הספר באמזון אינו זמין כרגע — קבלו עדכון כשהוא חוזר.",
      amazonNotifyCta: "עדכנו אותי כשחוזר",
      leadTitle: "קראו את הפרק הראשון",
      leadBody: "הזינו אימייל ואשלח לכם את הפרק הפותח ורשימת-בדיקה קצרה למדריך.",
      leadCta: "שלחו לי את הפרק",
      bulkTitle: "רכישה בכמות",
      bulkBody: "מאמנים יחידה או צוות? כתבו לי כמה עותקים תרצו ואסדר זאת.",
      bulkCta: "בקשת רכישה מרוכזת",
      authorTitle: "על המחבר",
      authorBody: "בני מאיר הקדיש את חייו להכשרה ולהדרכה של לוחמים ומדריכי לחימה במערכת הביטחון הישראלית — ארבעים שנה עם הלוחמים הטובים ביותר שיש לנו. מומחה באומנויות לחימה ובשיפור ביצועים אנושיים: יכולת תגובה, פיתוח כוח ותפקוד במצבי לחץ.",
      faqTitle: "שאלות נפוצות",
      faq: [
        { q: "מה כולל הספר?", a: "שלושה שערים — המורה, ההוראה והתלמיד — לאורך 208 עמודים." },
        { q: "אילו פורמטים זמינים?", a: "בעברית: דיגיטלי (₪40) ומודפס (₪98) בספרי ניב. באנגלית: כריכה רכה באמזון ובוולמארט." },
        { q: "האם יש משלוח לחו\"ל?", a: "כן — הכריכה הרכה באנגלית נשלחת לכל העולם דרך אמזון ווולמארט." },
        { q: "אפשר לרכוש בכמות לצוות?", a: "בהחלט. השתמשו בכפתור הרכישה המרוכזת ואחזור אליכם." },
      ],
      secondaryTitle: "הביאו את זה לארגון שלכם",
      secondaryBody: "מעדיפים חי? גלו את ההרצאות והסדנאות.",
      secondaryCta: "להרצאות ולסדנאות",
      backToSite: "לאתר הראשי",
      emailPlaceholder: "האימייל שלך *",
      namePlaceholder: "שם",
      notePlaceholder: "כמה עותקים, ולמי?",
      sending: "שולח…",
      thanks: "תודה — אחזור אליך בהקדם.",
      errorMsg: "משהו השתבש. אנא נסו שוב.",
    },
  },
};
